export default __webpack_public_path__ + "static/media/error.b2542792.jpg";